
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 30 30"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"currentColor","fill-rule":"nonzero"}},[_c('path',{attrs:{"d":"M22.865 21.455a.993.993 0 00-.993.993v2.148c0 .136-.11.247-.247.248l-15.39.024a.248.248 0 01-.25-.248V7.715c0-.137.112-.248.249-.248h1.241a.993.993 0 100-1.986h-1.49A1.976 1.976 0 004 7.442V24.87a1.975 1.975 0 001.986 1.96h15.886a1.975 1.975 0 001.986-1.96v-2.42a.993.993 0 00-.993-.994zM20.383 7.468h1.241c.137 0 .248.111.248.248v.745a.993.993 0 001.986 0v-.993c0-1.097-.889-1.986-1.986-1.986h-1.489a.993.993 0 000 1.986z"}}),_c('path',{attrs:{"d":"M10.95 8.461h5.958a1.49 1.49 0 001.49-1.49v-.496a1.49 1.49 0 00-1.49-1.49h-.993a1.986 1.986 0 10-3.972 0h-.993a1.49 1.49 0 00-1.489 1.49v.497c0 .822.667 1.489 1.49 1.489zM7.972 12.93c0 .547.444.992.993.992h7.943a.993.993 0 100-1.986H8.965a.993.993 0 00-.993.993zM8.965 16.9a.993.993 0 000 1.987h4.468a.993.993 0 100-1.986H8.965zM27.249 11.183a2.007 2.007 0 00-2.808 0l-7.813 7.814a.49.49 0 00-.11.167l-1.404 3.51a.496.496 0 00.645.644l3.51-1.404a.477.477 0 00.167-.11l7.813-7.813a1.986 1.986 0 000-2.808z"}})])])
          )
        }
      }
    